"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WinstonConsumer = void 0;
const react_1 = __importDefault(require("react"));
const WinstonContext_1 = require("./WinstonContext");
exports.WinstonConsumer = (props) => {
    const WinstonContext = WinstonContext_1.getWinstonContext();
    return (react_1.default.createElement(WinstonContext.Consumer, null, (context) => {
        if (!context || !context.logger) {
            throw new Error('Could not find "logger" in the context of WinstonConsumer. ' +
                'Wrap the root component in a <WinstonProvider>.');
        }
        return props.children(context.logger);
    }));
};
exports.default = exports.WinstonConsumer;
//# sourceMappingURL=WinstonConsumer.js.map